import { isNumber } from 'radash';

import { Poles } from '../validators/fields/Poles';

type BreakerPortSide = {
    poles?: Poles | null;
    voltagePerPole?: { value?: number | null } | null;
    voltage?: { nom?: number | null; max?: number | null } | null;
};

type MaxVoltage = { value: number; unit: 'V' };

/**
 * The highest voltage a breaker is rated for, and the second number on its product card.
 *
 * A rated max or nom wins over the series arithmetic. Summing the poles only describes a
 * breaker whose poles can be looped in series; one that protects both the POS and NEG
 * conductor cannot be, so multiplying by the pole count over-reports it — a 750 V two-pole
 * breaker was reading 1500 V.
 */
const getBreakerMaxVoltage = (side: BreakerPortSide | null | undefined): MaxVoltage | null => {
    const rated = [side?.voltage?.max, side?.voltage?.nom].find(isNumber);

    if (isNumber(rated)) {
        return { value: rated, unit: 'V' };
    }

    const voltagePerPole = side?.voltagePerPole?.value;
    const poleCount = side?.poles ? Poles.numericValueMap[side.poles] : undefined;

    if (!isNumber(voltagePerPole) || !isNumber(poleCount)) {
        return null;
    }

    return { value: voltagePerPole * poleCount, unit: 'V' };
};

export type { BreakerPortSide };
export { getBreakerMaxVoltage };
